import * as PIXI from "pixi.js";
//@ts-ignore
window.PIXI = PIXI;
import "pixi-spine";
import "pixi.js-legacy";
import "lodash";
import "gsap";
import GameModel from "../../vendor_core/core/src/model/GameModel";
import {
    HasRealityCheckCondition,
    ForceRealityCheckCondition,
} from "../../vendor_core/core/src/states/conditions/RealityCheckConditions";
import TRWFinishState from "./states/TRWFinishState";
import AlwaysTrueCondition from "../../vendor_core/core/src/states/conditions/AlwaysTrueCondition";
import HasRandomSymbolsCondition from "../../vendor_core/core/src/states/conditions/HasRandomSymbolsCondition";
import CombinedCondition, {
    ConditionCombinationType,
} from "../../vendor_core/core/src/states/conditions/CombinedCondition";
import { TRWHasBigWinCondition } from "./states/conditions/TRWHasBigWinCondition";
import TRWFreeSpinsWonCondition from "./states/conditions/TRWFreeSpinsWonCondition";
import { HasAutoplayCondition } from "../../vendor_core/core/src/states/conditions/HasAutoplayCondition";
import { HasFreeSpinsCondition } from "../../vendor_core/core/src/states/conditions/HasFreeSpinsCondition";
import { IsInFreeSpinsCondition } from "../../vendor_core/core/src/states/conditions/IsInFreeSpinsCondition";
import App from "../../vendor_core/core/src/App";
import InstanceFactory from "../../vendor_core/core/src/factories/InstanceFactory";
import Assets from "../../vendor_core/core/src/utils/Assets";
import GameLoader from "../../vendor_core/core/src/utils/GameLoader";
import Layout from "../../vendor_core/core/src/utils/Layout";
import SoundController from "../../vendor_core/core/src/utils/SoundController";
import SymbolMap from "../../vendor_core/core/src/utils/SymbolMap";
import TRWGameFactory from "./TRWGameFactory";
import Utils from "../../vendor_core/core/src/utils/Utils";
import * as asset_config from "../configs/asset-config-main.json";
import * as debug_config from "../configs/debug-config.json";
import * as game_config from "../configs/game-config.json";
import * as state_config from "../configs/state-config.json";
import ViewManager from "../../vendor_core/core/src/utils/ViewManager";
import stateMachine from "../../vendor_core/core/src/states/StateMachine";
import LoopLinesState from "../../vendor_core/core/src/states/LoopLinesState";
import { IStatesConfigSchema } from "../../vendor_core/core/src/states/State";
import BetModel from "../../vendor_core/core/src/model/BetModel";
import SpinModel from "../../vendor_core/core/src/model/SpinModel";
import DebugMenu from "../../vendor_core/core/src/utils/DebugMenu";
import CommManager from "../../vendor_core/core/src/controllers/CommManager";
import ErrorModel from "../../vendor_core/core/src/model/ErrorModel";
import ErrorDataParser from "../../vendor_core/src/server/parsers/errorDataParser";
import ErrorState from "../../vendor_core/src/states/ErrorState";
import TRWBuyFeaturePopups from "./ui/popups/TRWBuyFeaturePopups";
import MessagePopup from "../../vendor_core/core/src/ui/popups/MessagePopup";
import * as TRWGameCommands from "./ui/commands/TRWGameCommands";
import AutoplayPopup from "../../vendor_core/src/base/ui/AutoplayPopup";
import VendorAutoplayLimitPopup from "../../vendor_core/src/ui/popups/VendorAutoplayLimitPopup";
import BetPopup from "../../vendor_core/src/base/ui/BetPopup";
import { HasErrorCondition } from "../../vendor_core/core/src/states/conditions/HasErrorCondition";
import { HasExpandCondition } from "../../vendor_core/core/src/states/conditions/HasExpandCondition";
import UIController from "../../vendor_core/core/src/ui/UIController";
import VendorModel from "../../vendor_core/src/model/VendorModel";
import { Commands } from "../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../vendor_core/core/src/commands/CommandManager";
import * as GameCommands from "../../vendor_core/core/src/commands/GameCommands";
import * as VendorCommands from "../../vendor_core/src/commands/VendorCommands";
import { VendorCommandsEnum } from "../../vendor_core/src/commands/VendorCommandsEnum";
import AutoplayModel from "../../vendor_core/core/src/model/AutoplayModel";
import TRWSpinStartState from "./states/TRWSpinStartState";
import TRWSpinGetResultState from "./states/TRWSpinGetResultState";
import TRWSpinEndState from "./states/TRWSpinEndState";
import TRWascadeExplodeWinningsState from "./states/TRWCascadeExplodeWinningsState";
import TRWSpinResultState from "./states/TRWSpinResultState";

import TRWPreloaderState from "./states/TRWPreloaderState";
import TRWIdleState from "./states/TRWIdleState";
import { HasWinCondition } from "../../vendor_core/core/src/states/conditions/HasWinCondition";
import TRWEnterFreespinsState from "./states/TRWEnterFreespinsState";
import TRWExitFreespinsState from "./states/TRWExitFreespinsState";
import EnterRecoverState from "../../vendor_core/src/states/EnterRecoverState";
import HasRecovery from "../../vendor_core/src/states/conditions/HasRecovery";
import RecoverSpinStartState from "../../vendor_core/src/states/RecoverSpinStartState";
import TRWBigWinState from "./states/TRWBigWinState";
import TRWShowWinState from "./states/TRWShowWinState";
import CascadeFillRemainingState from "../../vendor_core/core/src/states/cascade/CascadeFillRemainingState";

//--------Fantasma prototype-------
import GameDataParser from "../../vendor_core/src/server/parsers/GameDataParser";
import BalanceDataParser from "../../vendor_core/src/server/parsers/BalanceDataParser";
import AutoplayDataParser from "../../vendor_core/src/server/parsers/AutoplayDataParser";
import TRWSpinDataParser from "./server/parsers/TRWSpinDataParser";
//---------------------------------

import CoinModel from "../model/CoinModel";
import TRWCoinDataParser from "./server/parsers/TRWCoinDataParser";
import BetDataParser from "../../vendor_core/src/server/parsers/BetDataParser";
import VendorDataParser from "../../vendor_core/src/server/parsers/VendorDataParser";
import InfoDataParser from "../../vendor_core/src/server/parsers/InfoDataParser";
import TRWBuyFeatureParser from "./server/parsers/TRWBuyFeatureParser";

import AuthorizationDataParser from "../../vendor_core/src/server/parsers/AuthorisationDataParser";

import { HasCascadeCondition } from "../../vendor_core/core/src/states/conditions/HasCascadeCondition";

import TRWCascadeSpinResultState from "./states/TRWCascadeSpinResultState";

import VendorWrapper from "../../vendor_core/src/controllers/VendorWrapper";
import ConfigManager from "../../vendor_core/core/src/managers/ConfigManager";
import SettingsConfig from "../configs/SettingConfig";
import BetConfig from "../configs/BetConfig";
import GameGeneralConfig from "../configs/GameGeneralConfig";
import ErrorConfig from "../configs/ErrorConfig";
import SymbolSpineAnimationConfig from "../configs/SymbolSpineAnimationsConfig";
import SpineAnimationsConfig from "../configs/SpineAnimationsConfig";
import SpineWinSymbolViewConfig from "../configs/SpineWinSymbolViewConfig";
import ReelsConfig from '../configs/ReelsConfig';
import GameLocalConfig from '../configs/GameLocalConfig';
import ComponentsConfig from "../configs/ComponentsConfig";

import TRWCoinState from "./states/TRWCoinState";
import TRWHasCoinCondition from "./states/conditions/TRWHasCoinCondition";

import TRWCoinRainState from "./states/TRWCoinRainState";
import TRWHasCoinRainCondition from "./states/conditions/TRWHasCoinRainCondition";

import TRWCollectCoinState from "./states/TRWCollectCoinState";
import TRWCascadeFillExplodedState from "./states/TRWCascadeFillExplodedState";
import TRWHasCoinToCollectCondition from "./states/conditions/TRWHasCoinToCollectCondition";

import "./styles/game.css";
import "../../vendor_core/core/static/styles/main.css";
import { utils as PixiUtils } from "pixi.js";
import EventEmitter = PixiUtils.EventEmitter;
import ConsoleUtil from "../../vendor_core/core/src/utils/ConsoleUtil";
import ErrorPopup from "../../vendor_core/core/src/ui/popups/ErrorPopup";
import InsufficientPopup from "../../vendor_core/src/ui/popups/InsufficientPopup";
import { RealityCheckState } from "../../vendor_core/core/src/states/RealityCheckState";
import TRWAuthorizationState from "./states/TRWAuthorizationState";
import BuyFeatureConfig from "../configs/BuyFeatureConfig";
import BuyFeatureModel from "../../vendor_core/core/src/model/BuyFeatureModel";

// TODO - move this to some class
const urlParams: any = {};
// test.doSomething();
declare const DEBUG: boolean;
// window.PIXI = PIXI;
location.search
    .substr(1)
    .split("&")
    .forEach((item) => {
        const tmp = item.split("=");
        if (tmp[0].length > 0) {
            urlParams[tmp[0]] = decodeURIComponent(tmp[1]);
        }
    });
ConsoleUtil.log("version : ", urlParams.version);

const link = document.createElement("link");

link.rel = "stylesheet";
link.href = "./styles/main.css?version=" + urlParams.version;
document.getElementsByTagName("head")[0].appendChild(link);

// TODO THIS NEEDS A LOT OF REFACTORING
const start = (params) => {
    // let gameLoader = new GameLoader(urlParams);
    const gameConfig = params.config;
    // GameLoader.loader.baseUrl = "";

    ConfigManager.registerConfigs([
        SymbolSpineAnimationConfig,
        SpineWinSymbolViewConfig,
        SpineAnimationsConfig,
        SettingsConfig,
        BetConfig,
        GameGeneralConfig,
        GameLocalConfig,
        ErrorConfig,
        ReelsConfig,
        BuyFeatureConfig,
        ComponentsConfig
    ]);

    GameModel.parseUrlParams(urlParams, gameConfig);

    GameModel.hasRealityCheck = false;
    GameLoader.loadFonts(gameConfig);
    // GameModel.apiConfig = loader.resources.apiConfig.data;
    // wait for fonts to load
    // window.onload = () => {
    const configs = GameModel.isMobile()
        ? asset_config.asset_configs.mobile
        : asset_config.asset_configs.desktop;
    GameLoader.loadConfig(configs, (loader) => {
        GameModel.apiConfig = loader.resources.apiConfig.data;
        GameLoader.loadConfig(
            loader.resources.asset_config.data.layoutConfigurations,
            (loader) => {
                const deviceWidth = Math.max(
                    window.screen.width,
                    window.screen.height
                );
                const START_WIDTH = Math.min(
                    deviceWidth,
                    loader.resources.layoutConfig.data.settings.nativeWidth
                );
                // const START_HEIGHT = loader.resources.layoutConfig.data.settings.nativeHeight;
                //  const START_WIDTH = Math.max(window.screen.width, window.screen.height);
                const START_HEIGHT = (START_WIDTH * 9) / 16;
                ConsoleUtil.log(START_WIDTH, START_HEIGHT);
                CommManager.setComm();
                CommManager.startPing(GameModel.gameConfig.pingDelay);
                initDefaultCommads();
                registerParsers();
                GameModel.update(urlParams);
                InstanceFactory.init(new TRWGameFactory());
                /* HTMLPopupsManager.init(
                    document.getElementById("content"),
                    HistoryHTMLPopup
                ); */
                const app = new App(
                    loader.resources.layoutConfig.data.settings
                );
                Layout.init(START_WIDTH, START_HEIGHT);
                Utils.serialize(gameConfig, GameModel);
                SymbolMap.init(GameModel.gameConfig.symbolResponseMap);
                SoundController.init();
                App.version = urlParams.version;
                // Layout.init(START_WIDTH, START_HEIGHT);
                App.assets = new Assets();
                App.utils = new Utils();
                App.dispatcher = new EventEmitter();

                window["ViewManager"] = ViewManager;
                window["App"] = App;
                window["Layout"] = Layout;
                window["UI"] = UIController;
                // ViewManager.init(layout_config, layerMap);
                const mainLayoutData = loader.resources.layoutConfig.data;
                const secondaryData = loader.resources.secondaryLayoutConfig
                    ? loader.resources.secondaryLayoutConfig.data
                    : null;
                ViewManager.init(
                    mainLayoutData,
                    loader.resources.layerMap.data,
                    secondaryData
                );
                VendorWrapper.init(START_WIDTH, START_HEIGHT);
                window.onresize = VendorWrapper.onResize.bind(VendorWrapper);
                document
                    .getElementById(params.config.container_name)
                    .appendChild(app.view);
                VendorWrapper.onResize();
                registerStates();
                setUpUIComponents();
                if (DEBUG) {
                    createDebugMenu();
                }

                function registerParsers() {
                    SpinModel.registerParser(new TRWSpinDataParser());
                    GameModel.registerParser(new AuthorizationDataParser());
                    BetModel.registerParser(new BalanceDataParser());
                    BetModel.registerParser(new BetDataParser());
                    VendorModel.registerParser(new VendorDataParser());
                    VendorModel.registerParser(new InfoDataParser());
                    ErrorModel.registerParser(new ErrorDataParser());
                    BuyFeatureModel.registerParser(new TRWBuyFeatureParser());

                    //-----Fantasma prototype-------
                    GameModel.registerParser(new GameDataParser());
                    AutoplayModel.registerParser(new AutoplayDataParser());
                    //------------------------------

                    // COIN RUSH //
                    CoinModel.registerParser(new TRWCoinDataParser())
                    // COIN RUSH //
                }

                function createDebugMenu() {
                    const debugMenu = new DebugMenu(
                        document.getElementById("content")
                    );
                    debugMenu.addDebugInput("Custom");
                    Object.keys(debug_config).forEach((key) => {
                        const element = debug_config[key];
                        if ("name" in element && "data" in element) {
                            debugMenu.addDebugCase(
                                element.name,
                                element.data,
                                false
                            );
                        }
                    });
                    debugMenu.menu.style.zIndex =
                        params.config.canvas_zIndex + 1;
                }

                function registerStates() {
                    stateMachine.registerState(
                        "init",
                        new TRWAuthorizationState(stateMachine)
                    );
                    stateMachine.registerState(
                        "preload",
                        new TRWPreloaderState(stateMachine)
                    );
                    stateMachine.registerState(
                        "idle",
                        new TRWIdleState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin",
                        new TRWSpinStartState(stateMachine)
                    );
                    stateMachine.registerState(
                        "get_spin_result",
                        new TRWSpinGetResultState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin_result",
                        new TRWSpinResultState(stateMachine)
                    );
                    stateMachine.registerState(
                        "cascade_result",
                        new TRWCascadeSpinResultState(stateMachine)
                    );
                    stateMachine.registerState(
                        "cascade_fill_remaining",
                        new CascadeFillRemainingState(stateMachine)
                    );
                    stateMachine.registerState(
                        "cascade_explode_winnings",
                        new TRWascadeExplodeWinningsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "cascade_fill_explode",
                        new TRWCascadeFillExplodedState(stateMachine)
                    );
                    stateMachine.registerState(
                        "coin",
                        new TRWCoinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "coin_rain",
                        new TRWCoinRainState(stateMachine)
                    );
                    stateMachine.registerState(
                        "coin_collect",
                        new TRWCollectCoinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin_end",
                        new TRWSpinEndState(stateMachine)
                    );
                    stateMachine.registerState(
                        "enter_freespins",
                        new TRWEnterFreespinsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "show_win",
                        new TRWShowWinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "big_win",
                        new TRWBigWinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "loop_lines",
                        new LoopLinesState(stateMachine)
                    );
                    stateMachine.registerState(
                        "error",
                        new ErrorState(stateMachine)
                    );
                    stateMachine.registerState(
                        "reality_check",
                        new RealityCheckState(stateMachine)
                    );
                    stateMachine.registerState(
                        "finish",
                        new TRWFinishState(stateMachine)
                    );
                    stateMachine.registerState(
                        "exit_freespins",
                        new TRWExitFreespinsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "recover_spin",
                        new RecoverSpinStartState(stateMachine)
                    );
                    stateMachine.registerState(
                        "recover",
                        new EnterRecoverState(stateMachine)
                    );

                    //** CONDITIONS **/
                    stateMachine.registerCondition(
                        "default",
                        new AlwaysTrueCondition()
                    );
                    stateMachine.registerCondition(
                        "hasBigWin",
                        new TRWHasBigWinCondition()
                    );
                    stateMachine.registerCondition(
                        "hasWin",
                        new HasWinCondition()
                    );
                    stateMachine.registerCondition(
                        "hasCoin",
                        new TRWHasCoinCondition()
                    );
                    stateMachine.registerCondition(
                        "hasCoinToCollect",
                        new TRWHasCoinToCollectCondition()
                    );
                    stateMachine.registerCondition(
                        "hasAutoplay",
                        new HasAutoplayCondition()
                    );
                    stateMachine.registerCondition(
                        "freespinsWon",
                        new TRWFreeSpinsWonCondition()
                    );
                    stateMachine.registerCondition(
                        "inFreespins",
                        new IsInFreeSpinsCondition()
                    );
                    stateMachine.registerCondition(
                        "hasError",
                        new HasErrorCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRealityCheck",
                        new HasRealityCheckCondition()
                    );
                    stateMachine.registerCondition(
                        "forceRealityCheck",
                        new ForceRealityCheckCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRandom",
                        new CombinedCondition(
                            [
                                new IsInFreeSpinsCondition(),
                                new HasRandomSymbolsCondition(),
                            ],
                            ConditionCombinationType.ALL
                        )
                    );
                    stateMachine.registerCondition(
                        "hasFreespins",
                        new HasFreeSpinsCondition()
                    );
                    stateMachine.registerCondition(
                        "hasExpand",
                        new HasExpandCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRecover",
                        new HasRecovery()
                    );
                    stateMachine.registerCondition(
                        "hasCascade",
                        new HasCascadeCondition()
                    );
                    stateMachine.registerCondition(
                        "hasCoinRain",
                        new TRWHasCoinRainCondition()
                    );
                    stateMachine.startStateMachine(
                        state_config as IStatesConfigSchema
                    );
                }

                function initDefaultCommads() {
                    CommandManager.setCommand(
                        Commands.SPIN,
                        TRWGameCommands.SpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.CLEAR_WIN,
                        GameCommands.ClearWinFieldCommand
                    );
                    CommandManager.setCommand(
                        Commands.SKIP,
                        GameCommands.SkipCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SPACE_TO_SPIN,
                        GameCommands.ToggleSpaceToSpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_TURBO_SPIN,
                        VendorCommands.ToggleTuboSpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SPACE_TURBO_SPIN,
                        GameCommands.ToggleSpaceTuboSpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.START_AUTOPLAY,
                        GameCommands.StartAutoplayCommand
                    );
                    CommandManager.setCommand(
                        Commands.STOP_AUTOPLAY,
                        GameCommands.StopAutoplayCommand
                    );
                    CommandManager.setCommand(
                        Commands.DECREMENT_AUTOPLAY,
                        GameCommands.DecrimentAutoplay
                    );
                    CommandManager.setCommand(
                        Commands.CLEAR_AUTOPLAY_LIMITS,
                        GameCommands.ClearAutoplayLimitsCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_LOSS_LIMIT,
                        GameCommands.SetAutoplayLossLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_SINGLE_WIN_LIMIT,
                        GameCommands.SetAutoplaySingleWinLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_TOTAL_WIN_LIMIT,
                        GameCommands.SetAutoplayTotalWinLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_ANY_WIN,
                        GameCommands.ToggleAutoplayStopOnWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_BIG_WIN,
                        GameCommands.ToggleAutoplayStopOnBigWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN,
                        GameCommands.ToggleAutoplayStopOnFeatureCommand
                    );
                    CommandManager.setCommand(
                        Commands.SHOW_ERROR,
                        GameCommands.ShowErrorPopup
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_STAKE_VALUE,
                        GameCommands.IterateStakeCommand
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_BET_VALUE,
                        GameCommands.IterateBetCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_MAX_BET,
                        GameCommands.SetMaxBetCommand
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_COIN_VALUE,
                        GameCommands.IterateCoinsCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_BET,
                        TRWGameCommands.SetBetCommand
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_TOTAL_BET,
                        GameCommands.IterateTotalBetCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_BALANCE,
                        GameCommands.UpdateBalanceCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_WIN,
                        GameCommands.UpdateWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_LANDSCAPE_RESTRICT,
                        GameCommands.ToggleLandscapeRestrict
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_TEMP_WIN,
                        GameCommands.UpdateTempWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_UI,
                        TRWGameCommands.UpdateUICommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_FREE_SPINS,
                        GameCommands.UpdateFreeSpinsCommand
                    );
                    CommandManager.setCommand(
                        Commands.AUDIO_VISIBLE_CHANGE_EVENTS,
                        TRWGameCommands.resetAudionCTX
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SETTINGS,
                        TRWGameCommands.ToggleSettingsCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.GAME_PAUSED,
                        VendorCommands.ToggleGamePauseCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_PAYTABLE,
                        GameCommands.TogglePaytableCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_POPUP,
                        TRWGameCommands.ToggleAutoplayPopupCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_BET_POPUP,
                        TRWGameCommands.ToggleBetPopupCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_SOUND_CONTROLLER,
                        VendorCommands.ToggleSoundPopupCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_SOUND_BUTTON,
                        VendorCommands.ToggleSoundButtonCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SOUND_FX,
                        GameCommands.ToggleSoundFXCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_MUSIC,
                        GameCommands.ToggleMusicCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.UPDATE_JACKPOTS,
                        VendorCommands.UpdateJackpotsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_MASTER_SOUND,
                        GameCommands.ToggleMasterSoundCommand
                    );
                    CommandManager.setCommand(
                        Commands.SAVE_SETTINGS,
                        GameCommands.SaveSettingsCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_JACKPOTS_BUTTON,
                        VendorCommands.ToggleJackpotBtnCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_MASTER_VOLUME,
                        GameCommands.SetMasterVolumeCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.SHOW_INSUFFICIENT_FUNDS_MESSAGE,
                        VendorCommands.ShowInsufficientFoundsDialog
                    );
                    CommandManager.setCommand(
                        Commands.GO_HOME,
                        VendorCommands.GoHome
                    );
                    CommandManager.setCommand(
                        Commands.CLOSE_SETTINGS,
                        GameCommands.CloseSettingsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_BUY_FEATURE,
                        GameCommands.ShowBuyFeaturePopup
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.FEATURE_BUTTON_OPTIONS,
                        TRWGameCommands.ShowBuyFeatureOptions
                    );
                    CommandManager.setCommand(
                        Commands.FEATURE_BUY_SPIN,
                        GameCommands.BuyFeatureSpin
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_CASCADE_HISTORY,
                        GameCommands.UpdateCascadeHistory
                    );
                    CommandManager.setCommand(
                        Commands.CLEAR_CASCADE_HISTORY,
                        GameCommands.ClearCascadeHistory
                    );
                    CommandManager.setCommand(
                        Commands.REQUEST_HISTORY,
                        VendorCommands.showHistory
                    );
                }

                function setUpUIComponents() {
                    UIController.setComponent("main", InstanceFactory.getClass("UIView"));
                    UIController.setComponent("settings", InstanceFactory.getClass("Settings"));
                    UIController.setComponent("autoplayPopup", new AutoplayPopup());
                    UIController.setComponent("autoplayLimitPopup", new VendorAutoplayLimitPopup());
                    UIController.setComponent("betPopup", new BetPopup());
                    // UIController.setComponent("soundPopup", new SoundPopup()); //* lemmy - Is it necessary to remove this?
                    UIController.setComponent("messagePopup", new MessagePopup());
                    UIController.setComponent("buyFeature", new TRWBuyFeaturePopups());
                    UIController.setComponent("errorPopup", new ErrorPopup());
                    UIController.setComponent("insufficientFundsPopup", new InsufficientPopup());
                    // UIController.setComponent('cascadeHistory', new UICascadeHistory());
                }
            }
        );
    });
};

window.onload = () => {
    start({ config: game_config });
};
